import { Layout, Menu, Avatar } from 'antd';
import { publicationList, academicActivities, intellectualProperties } from '../config';
import './index.css';

const Publications = () => {
    return (
        <div className='publications'>
            <h1>Publications (Google Scholar Citation: 857)</h1>

            {/* Secured AI Agent for Operation and Control of Power Systems */}
            <div className='publication-container'>
                <h2>Secured AI Agent for Operation and Control of Power Systems:</h2>
                {publicationList?.securedAIAgent?.map((pub, index) => (
                    <div key={index} className="publication">
                        <p className="publication-title">{`[${index + 1}] ${pub.title}`}</p>
                        <p className="publication-details">{`${pub.source}, ${pub.year}. (Citation: ${pub.citationCount})`}</p>
                        {pub.extraInfo && <p className="extra-info">{pub.extraInfo}</p>}
                    </div>
                )) || <p>No publications available.</p>}
            </div>

            {/* Advanced Data Analytics for Reliability of Industrial Systems */}
            <div className='publication-container'>
                <h2>Advanced Data Analytics for Reliability of Industrial Systems:</h2>
                {publicationList?.advancedDataAnalytics?.map((pub, index) => (
                    <div key={index} className="publication">
                        <p className="publication-title">{`[${index + 1}] ${pub.title}`}</p>
                        <p className="publication-details">{`${pub.source}, ${pub.year}. (Citation: ${pub.citationCount})`}</p>
                    </div>
                )) || <p>No publications available.</p>}
            </div>

            {/* Cyber Security for Power Systems */}
            <div className='publication-container'>
                <h2>Cyber Security for Power Systems with Machine Learning:</h2>
                {publicationList?.cyberSecurity?.map((pub, index) => (
                    <div key={index} className="publication">
                        <p className="publication-title">{`[${index + 1}] ${pub.title}`}</p>
                        <p className="publication-details">{`${pub.source}, ${pub.year}. (Citation: ${pub.citationCount})`}</p>
                    </div>
                )) || <p>No publications available.</p>}
            </div>

            {/* Intellectual Properties */}
            <div className='publication-container'>
                <h2>Intellectual Properties:</h2>

                {/* Authorized Patents */}
                <div className="intellectual-section">
                    <h3>Authorized Patents:</h3>
                    {intellectualProperties?.authorizedPatents?.map((patent, index) => (
                        <div key={index} className="intellectual-property">
                            <p className="intellectual-title">{`[${index + 1}] ${patent.title}`}</p>
                            <p className="intellectual-details">{`Patent #${patent.patentNumber} (${patent.type}, ${patent.status})`}</p>
                        </div>
                    )) || <p>No patents available.</p>}
                </div>

                {/* Published Patents */}
                <div className="intellectual-section">
                    <h3>Published Patents:</h3>
                    {intellectualProperties?.publishedPatents?.map((patent, index) => (
                        <div key={index} className="intellectual-property">
                            <p className="intellectual-title">{`[${index + 1}] ${patent.title}`}</p>
                            <p className="intellectual-details">{`Patent #${patent.patentNumber} (${patent.status})`}</p>
                        </div>
                    )) || <p>No patents available.</p>}
                </div>

                {/* Technical Disclosures */}
                <div className="intellectual-section">
                    <h3>Technical Disclosures:</h3>
                    {intellectualProperties?.technicalDisclosures?.map((disclosure, index) => (
                        <div key={index} className="intellectual-property">
                            <p className="intellectual-title">{`[${index + 1}] ${disclosure.title}`}</p>
                            <p className="intellectual-details">{`Disclosure #${disclosure.disclosureNumber}`}</p>
                        </div>
                    )) || <p>No disclosures available.</p>}
                </div>
            </div>

        </div>
    );
}

export default Publications;
